import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Input, Button, Form, Switch, Message, Tooltip } from 'antd'
import Popconfirm from '../../components/Popconfirm/Popconfirm2'
import { QuestionCircleFilled } from '@ant-design/icons'
import NewModal from './components/newModal'
import {
  fetchPrinterList,
  fetchUnionPrinterDetail,
  fetchReceiptTypes,
  postPrinterData,
  postPrinterTest,
  removePrinter,
  fetchPrinterStatus,
} from '../../api/printer'
import { getCategories } from '../../api/businessCommodity'
import './style.css'

class ClubPrinterManage extends Component {
  state = {
    newVisible: false,
    printerList: [],
    currentIndex: 0,
    printerDetail: {
      name: '',
      shouldPrintReceipts: true,
      printReceiptTypes: {},
      shouldPrintProducingReceipts: true,
      printProducingReceiptCommodityCategoryIds: {},
    },
    receiptTypes: [],
    categoryList: [],
  }

  componentDidMount() {
    this.getPrinterList(this.choosePrinter)
    this.getReceiptTypes()
    this.getCategoryList()
  }

  // 俱乐部小票机列表
  getPrinterList = async (callback) => {
    const clubId = sessionStorage.getItem('club_id')
    const { data, status, detail } = await fetchPrinterList({
      clubId,
    })
    if (status != 1) {
      Message.error(detail)
      return
    }
    if (data.length == 0) {
      return
    }
    data.map((item, index) => {
      item.statusStr = ''
    })
    let firstObj = {}
    data.length > 0 &&
      data.map((item, index) => {
        if (item.type == 1) {
          firstObj = item
          data.splice(index, 1)
          return
        }
      })
    if (firstObj.id) {
      data.unshift(firstObj)
    }
    this.setState(
      {
        printerList: data,
      },
      () => {
        this.getPrinterStatus(this.state.printerList)
        callback && callback(firstObj.id ? firstObj : data[0], 0)
      }
    )
  }

  // 点击选择打印机
  choosePrinter = async (item, index) => {
    if (this.state.printerList.length == 0) {
      return
    }
    const { data, status, detail } = await fetchUnionPrinterDetail({
      printerId: item.id,
    })
    if (status != 1) {
      Message.error(detail)
      return
    }
    this.setState({
      printerDetail: data,
      currentIndex: index,
    })
  }

  // 获取小票机状态
  getPrinterStatus = async (list) => {
    let arr = []
    list.length > 0 &&
      list.map((item, index) => {
        arr.push(item.id)
      })
    const { data, status, detail } = await fetchPrinterStatus({
      printerIds: arr,
    })
    if (status != 1) {
      Message.error(detail)
      return
    }
    const { printerList } = this.state
    data.length > 0 &&
      data.map((item, index) => {
        printerList.length > 0 &&
          printerList.map(($item, $index) => {
            if (item.printer.id == $item.id) {
              if (item.status == 1) {
                $item.statusStr = '在线'
              }
              if (item.status == 64) {
                $item.statusStr = '离线'
              }
              if (item.status == 65) {
                $item.statusStr = '无纸'
              }
            }
          })
      })
    this.setState({
      printerList: printerList,
    })
  }

  // 普通小票类型列表
  getReceiptTypes = async () => {
    const { data, status, detail } = await fetchReceiptTypes()
    if (status != 1) {
      Message.error(detail)
      return
    }
    this.setState({
      receiptTypes: data,
    })
  }

  // 是否选中
  findChecked = (key) => {
    const { receiptTypes } = this.state
    const { printReceiptTypes } = this.state.printerDetail
    if (receiptTypes.length == 0) {
      return false
    }
    // printReceiptTypes.length > 0 &&
    //   printReceiptTypes.map((item, index) => {
    //     if (printReceiptTypes[key]) {
    //       return true
    //     } else {
    //       return false
    //     }
    //   })
    if (Object.hasOwn(printReceiptTypes, key) && printReceiptTypes[key]) {
      return true
    } else {
      return false
    }
  }

  // 获取商品分类列表
  getCategoryList = async () => {
    const clubId = sessionStorage.getItem('club_id')
    const { data, status, detail } = await getCategories(clubId)
    if (status != 1) {
      Message.error(detail)
      return
    }
    this.setState({
      categoryList: data,
    })
  }

  // 保存信息
  savePrinter = async () => {
    const { data, status, detail } = await postPrinterData({
      setting: this.state.printerDetail,
    })
    if (status != 1) {
      Message.error(detail)
      return
    }
    Message.success('保存成功')
    this.getPrinterList()
  }

  // 打印测试
  printerTest = async () => {
    const { data, status, detail } = await postPrinterTest({
      printerId: this.state.printerDetail.printerId,
    })
    if (status != 1) {
      Message.error(detail)
      return
    }
  }

  // 删除小票机
  deletePrinter = async () => {
    const { data, status, detail } = await removePrinter({
      printerSettingId: this.state.printerDetail.id,
    })
    if (status != 1) {
      Message.error(detail)
      return
    }
    Message.success('删除成功')
    this.setState(
      {
        currentIndex: 0,
      },
      () => {
        this.getPrinterList(this.choosePrinter)
      }
    )
  }

  openModal = () => {
    this.setState({
      newVisible: true,
    })
  }

  onNewOk = () => {
    this.setState({
      newVisible: false,
    })
  }

  onNewCancel = () => {
    this.setState({
      newVisible: false,
    })
  }

  render() {
    const {
      printerList,
      currentIndex,
      receiptTypes,
      categoryList,
      printerDetail,
    } = this.state

    return (
      <div
        style={{
          display: 'flex',
        }}
      >
        <div
          style={{
            flex: 1,
            marginRight: '20px',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'right',
            }}
          >
            <Button type="primary" onClick={this.openModal}>
              新增小票机
            </Button>
          </div>
          {printerList.length > 0 && (
            <div
              style={{
                border: '1px solid #ccc',
                padding: '20px',
                boxSizing: 'border-box',
                marginTop: '10px',
              }}
            >
              {printerList.length > 0 &&
                printerList.map((item, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '10px',
                        boxSizing: 'border-box',
                        margin: '10px 0',
                      }}
                      className={index == currentIndex ? 'active_printer' : ''}
                      onClick={() => {
                        this.choosePrinter(item, index)
                      }}
                    >
                      <div>{item.name}</div>
                      <div>
                        {item.type == 1 ? (
                          '默认'
                        ) : (
                          <div>
                            <span
                              style={{
                                color:
                                  item.statusStr == '在线' ? '#52c41a' : '#ccc',
                              }}
                            >
                              {item.statusStr}
                            </span>
                            <Tooltip placement="right" title="会有30s~5min延迟">
                              <QuestionCircleFilled
                                style={{
                                  color: '#ccc',
                                  marginLeft: '10px',
                                }}
                              />
                            </Tooltip>
                          </div>
                        )}
                      </div>
                    </div>
                  )
                })}
            </div>
          )}
        </div>

        {printerList.length > 0 && (
          <div
            style={{
              width: '70%',
              border: '1px solid #ccc',
              padding: '20px',
              boxSizing: 'border-box',
              marginTop: '42px',
            }}
          >
            <div className="title">
              {this.state.printerList.length > 0
                ? this.state.printerList[this.state.currentIndex].name
                : ''}
            </div>

            <div
              style={{
                fontSize: '16px',
                marginTop: '20px',
              }}
            >
              基础信息
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                marginBottom: '20px',
              }}
            >
              <div>小票机名称</div>
              <Input
                style={{ width: '300px' }}
                value={this.state.printerDetail.name}
                onChange={(e) => {
                  let printerDetail = this.state.printerDetail
                  printerDetail.name = e.target.value
                  this.setState({
                    printerDetail: printerDetail,
                  })
                }}
              />
            </div>

            <div
              style={{
                fontSize: '16px',
                marginTop: '30px',
              }}
            >
              关联小票
            </div>
            <div
              style={{
                display: 'flex',
              }}
            >
              <div style={{ width: '50%' }}>
                <Form
                  labelAlign="left"
                  labelCol={{
                    span: 6,
                  }}
                  wrapperCol={{
                    span: 18,
                  }}
                >
                  <Form.Item label="前台小票">
                    <Switch
                      checked={this.state.printerDetail.shouldPrintReceipts}
                      onChange={(value) => {
                        let printerDetail = this.state.printerDetail
                        printerDetail.shouldPrintReceipts = value
                        this.setState({
                          printerDetail: printerDetail,
                        })
                      }}
                    />
                  </Form.Item>
                </Form>

                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    // gap: '50px',
                    width: '100%',
                  }}
                >
                  {receiptTypes.length > 0 &&
                    receiptTypes.map((item, index) => {
                      return (
                        <div style={{ marginRight: '50px' }} key={index}>
                          <Form
                            labelAlign="left"
                            labelCol={{
                              span: 16,
                            }}
                            wrapperCol={{
                              span: 8,
                            }}
                          >
                            <Form.Item label={item.description}>
                              <Switch
                                // checked={() => {
                                //   this.findChecked(item.value)
                                // }}
                                checked={
                                  this.state.printerDetail.printReceiptTypes[
                                    item.value
                                  ]
                                }
                                onChange={(value) => {
                                  let printerDetail = this.state.printerDetail
                                  printerDetail.printReceiptTypes[item.value] =
                                    value
                                  this.setState({
                                    printerDetail: printerDetail,
                                  })
                                }}
                                disabled={
                                  !this.state.printerDetail.shouldPrintReceipts
                                }
                              />
                            </Form.Item>
                          </Form>
                        </div>
                      )
                    })}
                </div>
              </div>

              <div style={{ width: '50%' }}>
                <Form
                  labelAlign="left"
                  labelCol={{
                    span: 6,
                  }}
                  wrapperCol={{
                    span: 18,
                  }}
                >
                  <Form.Item label="制作小票">
                    <Switch
                      checked={
                        this.state.printerDetail.shouldPrintProducingReceipts
                      }
                      onChange={(value) => {
                        let printerDetail = this.state.printerDetail
                        printerDetail.shouldPrintProducingReceipts = value
                        this.setState({
                          printerDetail: printerDetail,
                        })
                      }}
                    />
                  </Form.Item>
                </Form>

                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    // gap: '50px',
                    width: '100%',
                  }}
                >
                  {categoryList.length > 0 &&
                    categoryList.map((item, index) => {
                      return (
                        <div style={{ marginRight: '50px' }} key={index}>
                          <Form
                            labelAlign="left"
                            labelCol={{
                              span: 16,
                            }}
                            wrapperCol={{
                              span: 8,
                            }}
                          >
                            <Form.Item label={item.name}>
                              <Switch
                                // checked={() => {
                                //   this.findChecked(item.value)
                                // }}
                                checked={
                                  this.state.printerDetail
                                    .printProducingReceiptCommodityCategoryIds[
                                    item.id
                                  ]
                                }
                                onChange={(value) => {
                                  let printerDetail = this.state.printerDetail
                                  printerDetail.printProducingReceiptCommodityCategoryIds[
                                    item.id
                                  ] = value
                                  this.setState({
                                    printerDetail: printerDetail,
                                  })
                                }}
                                disabled={
                                  !this.state.printerDetail
                                    .shouldPrintProducingReceipts
                                }
                              />
                            </Form.Item>
                          </Form>
                        </div>
                      )
                    })}
                </div>
              </div>
            </div>

            <div>
              <Button type="primary" onClick={this.savePrinter}>
                保存
              </Button>
            </div>

            <div
              style={{
                fontSize: '16px',
                marginTop: '30px',
                marginBottom: '10px',
              }}
            >
              操作
            </div>
            <div
              style={{
                display: 'flex',
                gap: '20px',
              }}
            >
              <Button type="primary" onClick={this.printerTest}>
                打印测试
              </Button>
              {printerDetail.type != 1 && (
                <Popconfirm
                  placement="top"
                  title="确定删除此小票机?"
                  onConfirm={this.deletePrinter}
                  okText="是"
                  cancelText="否"
                >
                  <Button type="danger">删除小票机</Button>
                </Popconfirm>
              )}
            </div>
          </div>
        )}

        {this.state.newVisible && (
          <NewModal
            newVisible={this.state.newVisible}
            // onNewOk={this.onNewOk}
            onNewCancel={this.onNewCancel}
            getPrinterList={this.getPrinterList}
            choosePrinter={this.choosePrinter}
          ></NewModal>
        )}
      </div>
    )
  }
}

export default withRouter(ClubPrinterManage)



// WEBPACK FOOTER //
// ./src/containers/ClubPrinterManage/index.js